export class ShareEventUrlsConstatns {
    public static readonly GoogleURL = 'https://calendar.google.com/calendar/r/eventedit?';
    public static readonly OutlookURL = 'https://outlook.office.com/owa/?path=/calendar/action/compose&rru=addevent';
}